/**
 * Expose a single entry point where both the client and server can use
 */
const config = {
  sso: {
    SERVER_HOST: process.env.SSO_SERVER_HOST,
    API_KEY: process.env.SSO_API_KEY,
    RECAPTCHA_KEY: process.env.RECAPTCHA_KEY
  },
  jwt: {
    PUBLIC_KEY: process.env.JWT_PUBLIC_KEY
  },
  marketplaceApi: {
    URL: process.env.MARKETPLACE_API_URL,
    SECRET: process.env.X_ENVATO_SECRET
  },
  eventsApi: {
    URL: process.env.EVENTS_API_URL
  },
  discoveryUser: {
    PUBLIC_SEARCH_API_URL: process.env.PUBLIC_SEARCH_API_URL,
    RECOMMENDATION_API_URL: process.env.RECOMMENDATION_API_URL
  },
  db: {
    REDIS_URL: process.env.REDIS_URL
  },
  analytics: {
    rollbar: {
      CLIENT_SIDE_TOKEN: process.env.ROLLBAR_CLIENT_SIDE_TOKEN,
      SERVER_SIDE_TOKEN: process.env.ROLLBAR_SERVER_SIDE_TOKEN
    },
    newrelic: {
      ENABLED: process.env.NEW_RELIC_ENABLED,
      LICENSE_KEY: process.env.NEW_RELIC_LICENSE_KEY
    },
    affiliate: {
      MARKETPLACE_URL: process.env.MARKETPLACE_URL
    },
    intercom: {
      APP_ID: process.env.INTERCOM_APP_ID,
      SECRET: process.env.INTERCOM_SECRET
    }
  },
  assets: {
    PUBLIC_PATH: process.env.PUBLIC_PATH
  }
}

export default config



// WEBPACK FOOTER //
// ./common/config.js